import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DepositPerTicketComponent } from './deposit-per-ticket.component';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { DepositResultComponent } from './deposit-result/deposit-result.component';
import { DepositDataComponent } from './deposit-data/deposit-data.component';
import { DepositConfirmationComponent } from './deposit-confirmation/deposit-confirmation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { DepositPerTicketService } from './deposit-per-ticket.service'

@NgModule({
	imports: [
		SharedModule,
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		NgxMaskModule.forRoot(),
		CurrencyMaskModule
	],
	declarations: [
		DepositPerTicketComponent,
		DepositResultComponent,
		DepositDataComponent,
		DepositConfirmationComponent
	],
	exports: [
		DepositPerTicketComponent
	],
	providers: [
		DepositPerTicketService,
		{provide: LOCALE_ID, useValue: 'pt-BR'}
	]
})
export class DepositPerTicketModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/deposit-per-ticket/deposit-per-ticket.module.ts